module.exports = __webpack_public_path__ + "img/SalesIcon.b93449af.png";